import dayjs from "dayjs";
import { get, isEmpty } from "lodash";
import { CONTACT_POINT_SYSTEM, DATE_FORMAT } from "utils/constants";
import { isMajor } from "utils/helpers/date";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import { Col, Row } from "antd";
import { bindInputProps } from "utils/helpers/input";
import { useFormik } from "formik";
import { NAME_SPACES } from "shared/locales/constants";
import { useTranslation } from "react-i18next";
import ActionButtons from "../Components/ActionButtons";
import validation from "./validation";

function View({ telecoms, contact, onNext, onBack }) {
  const { t } = useTranslation();

  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      telecoms,
      birthDate: get(contact, "user.birthDate") || null,
    },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
    ),
    validateOnChange: true,
    validateOnBlur: true,
  });

  const isDisabled =
    !get(values, `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`) ||
    !values.birthDate;

  return (
    <Layout>
      <Header
        title="Quelques informations pour personnaliser votre offre"
        highlight="personnaliser votre offre"
        subtitle="Informations de l’adhérent"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={12}>
          <div className="grid--1">
            <Input
              type="date"
              format={DATE_FORMAT}
              placeholder={"JJ / MM / AAAA"}
              label={"Date de naissance"}
              value={values.birthDate ? dayjs(values.birthDate) : undefined}
              disabledDate={(current) => current > isMajor}
              defaultPickerValue={!values.birthDate && dayjs().subtract(30, "years")}
              onChange={(date) => {
                if (date?.isValid() && date.isBefore(isMajor)) {
                  setFieldValue(
                    "birthDate",
                    date.set("hour", 2).set("minute", 0).set("second", 0).toISOString()
                  );
                }
              }}
              onBlur={({ target: { value } }) => {
                const date = dayjs(value, DATE_FORMAT);
                if (date.isValid())
                  setFieldValue("birthDate", date ? date.add(2, "h").toISOString() : null);
              }}
            />

            <Input
              type={"number"}
              placeholder={"ex : 69001"}
              maxLength={5}
              label={"Code postal"}
              {...bindInputProps({
                name: `telecoms.${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
                values,
                ...formProps,
              })}
              
            />
          </div>
        </Col>
      </Row>

      <ActionButtons
        disabled={isDisabled}
        onNext={handleSubmit}
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
